import { CART_SEARCH } from './action_types';

const searchCarts = payload => ({
  type: CART_SEARCH,
  payload: payload
});

export { searchCarts };
